module.exports = __webpack_public_path__ + "assets/img/picture1.3615e17f.svg";